export default __webpack_public_path__ + "static/media/026-bronze medal.964a07d5.svg";